import { useEffect } from 'react';
import { useParams, Link } from 'react-router-dom';
import { getArticlesByCategory } from '@/mocks/articles';
import { categories } from '@/mocks/categories';

export default function ArticleListCard({ article }: { article: { slug: string; title: string; excerpt: string; imageUrl: string; date: string; readTime: string } }) {
  return (
    <Link
      to={`/article/${article.slug}`}
      className="group flex flex-col sm:flex-row bg-background-50 rounded-xl overflow-hidden hover:bg-background-100 transition-all duration-300 cursor-pointer"
    >
      <div className="w-full sm:w-56 md:w-64 h-44 sm:h-auto flex-shrink-0 overflow-hidden">
        <img
          src={article.imageUrl}
          alt={article.title}
          className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
        />
      </div>
      <div className="flex-1 p-5 md:p-6 flex flex-col justify-center">
        <div className="flex items-center gap-3 text-xs text-foreground-400 mb-2">
          <span>{article.date}</span>
          <span className="w-1 h-1 rounded-full bg-foreground-300"></span>
          <span>{article.readTime}</span>
        </div>
        <h3 className="text-base md:text-lg font-semibold text-foreground-900 group-hover:text-primary-600 transition-colors line-clamp-2 leading-snug">
          {article.title}
        </h3>
        <p className="mt-2 text-sm text-foreground-500 line-clamp-2 leading-relaxed">
          {article.excerpt}
        </p>
        <div className="mt-4 flex items-center gap-1.5 text-sm font-medium text-primary-600">
          阅读全文 <i className="ri-arrow-right-line text-xs"></i>
        </div>
      </div>
    </Link>
  );
}